"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderFuturesList = exports.OrderList = void 0;
const constants_1 = require("../config/constants");
class OrderList {
    constructor(params) {
        this.orders = new Map();
        this.positions = new Map();
        this.lastFetch = 0;
        this.config = {
            removeInactive: false,
        };
        this.marketData = {
            marketAssets: new Map()
        };
        this.assetsUpdateStats = {
            assetsNew: new Map(),
            assetsNull: new Map(),
            knownAssets: new Map(),
        };
        if (this.constructor === OrderList) {
            throw new Error("Abstract classes can't be instantiated.");
        }
        const { fetchOrders, config, marketData } = params;
        if (config !== undefined)
            this.config = config;
        this.fetchOrders = fetchOrders;
        this.lastFetch = new Date().getTime();
        if (marketData)
            this.marketData = marketData;
    }
    static load(orders) { }
    clear() {
        this.orders.clear();
    }
    reset() {
        return __awaiter(this, void 0, void 0, function* () {
            this.clear();
            const fetched = yield this.fetchInitial();
            this.update(fetched);
        });
    }
    clearSubscriptionsList() {
        const knownAssets = Array.from(this.assetsUpdateStats.assetsNew.entries(), ([key]) => {
            return key;
        });
        knownAssets.forEach((asset) => {
            var _a;
            (_a = this.assetsUpdateStats.knownAssets) === null || _a === void 0 ? void 0 : _a.set(asset, asset);
        });
        this.assetsUpdateStats.assetsNew.clear();
        this.assetsUpdateStats.assetsNull.clear();
    }
    get ordersArray() {
        return Array.from(this.orders, ([, value]) => value);
    }
    get data() {
        return {
            ordersArray: this.ordersArray,
            orders: this.orders,
        };
    }
}
exports.OrderList = OrderList;
class OrderFuturesList extends OrderList {
    constructor(params) {
        super(params);
        const { fetchPositions } = params;
        this.fetchPositions = fetchPositions;
    }
    clear() {
        super.clear();
        this.positions.clear();
    }
    get positionsArray() {
        return Array.from(this.positions, ([, value]) => value);
    }
    get unrealizedPnl() {
        return this.positionsArray.reduce((acc, position) => {
            return acc.plus(position.unrealizedPnl);
        }, constants_1.BN_ZERO).toString();
    }
    get data() {
        const data = super.data;
        return Object.assign(Object.assign({}, data), { positionsArray: this.positionsArray, positions: this.positions, unrealizedPnl: this.unrealizedPnl, totalMarginBalance: this.totalMarginBalance });
    }
    updateExchageInfo(exchangeInfo) {
        this.exchangeInfo = exchangeInfo;
    }
}
exports.OrderFuturesList = OrderFuturesList;
